import { useState } from "react";
import { DocumentViewer, MiList } from "@miplatform/components";
import {
  IAttemptListItemResponseForWorkOrder,
  IDocumentListItemResponse,
} from "@miplatform/types";
import { useDocumentsViewModel } from "@miplatform/view-models";
import { DocumentCard, EmptyMessageView } from "@mibuildweb/components";
import { Box } from "@mui/material";

export const WorkOrderDrawerDocumentsTab = ({
  attempt,
}: {
  attempt: IAttemptListItemResponseForWorkOrder;
}) => {
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentListItemResponse | null>(null);
  const { documents = [] } = attempt;

  const { printFile, downloadFile, loading } = useDocumentsViewModel();

  if (documents.length === 0) {
    return (
      <EmptyMessageView
        title="No Documents"
        subtitle="No documents have been added to this work order yet"
      />
    );
  }

  return (
    <Box>
      <MiList
        viewType="card"
        data={documents}
        CardComponent={DocumentCard}
        cardProps={{
          hideUploadedBy: true,
          onPrint: printFile,
          onDownload: downloadFile,
          onSelect: setSelectedDocument,
          selectedDoc: selectedDocument,
          disableDelete: true,
        }}
        loading={loading}
        hideListPagination
      />
      <DocumentViewer
        documents={[
          selectedDocument,
          ...documents.filter((d) => d.id !== selectedDocument?.id),
        ]}
        onUnfullscreen={() => setSelectedDocument(null)}
        fullScreenStatus={!!selectedDocument}
      />
    </Box>
  );
};
